module.exports = __webpack_public_path__ + "img/170.1eee8401.jpg";